module.exports = __webpack_public_path__ + "img/img-1.75dd7294.jpeg";